/**
 * @generated SignedSource<<628a6e79dc68959df5a2d3dbc5f63e6e>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PreferencesDialog_query$data = {
  readonly analytics: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly value: string;
      };
    }>;
    readonly " $fragmentSpreads": FragmentRefs<"useProblemsAlert_problems">;
  };
  readonly " $fragmentType": "PreferencesDialog_query";
};
export type PreferencesDialog_query$key = {
  readonly " $data"?: PreferencesDialog_query$data;
  readonly " $fragmentSpreads": FragmentRefs<"PreferencesDialog_query">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PreferencesDialog_query",
  "selections": [
    {
      "alias": "analytics",
      "args": [
        {
          "kind": "Literal",
          "name": "filterElement",
          "value": {
            "single": {
              "name": "name",
              "operator": "equals",
              "value": "analytics_enabled"
            }
          }
        }
      ],
      "concreteType": "UserDataConnection",
      "kind": "LinkedField",
      "name": "userData",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "UserDataEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "UserData",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "value",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "useProblemsAlert_problems"
        }
      ],
      "storageKey": "userData(filterElement:{\"single\":{\"name\":\"name\",\"operator\":\"equals\",\"value\":\"analytics_enabled\"}})"
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "268fa0a2641e3f294b9b700598f10faa";

export default node;
